import styles from "./styles.module.css";
import Item from "./item";
import AddHook from "./addhook";
import { WebhooksValue } from "../../../contexts/webhooks";
import { useContext } from "react";

export default function Webhooks({ selected }) {
  const webhooks = useContext(WebhooksValue);
  return (
    <div className={styles.container}>
      <AddHook />
      {webhooks.map((hook) => {
        return (
          <Item
            onClick={() => selected.set(hook)}
            active={selected.value?.id === hook.id}
            key={hook.id}
            name={hook.name}
          />
        );
      })}
    </div>
  );
}
